//BookShelfListComponents.jsx
import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import Tooltip from '../../components/utils/Tooltip';

// import MLMButtonWithCount from './MLMButtonWithCount';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faPlay, faTimes, faBookOpen, faGifts, faTv, faUserFriends, faUserPlus, faUserTie, faUsers, faStop, faComment, faBarChart, faDiagramProject, faUserClock, faFileInvoiceDollar } from '@fortawesome/free-solid-svg-icons';
import './styles/BookShelfListComponent.css';
import './styles/ThinkleticsTables.css';

// import MultiLevelReferralTable from './MultiLevelReferralTable';
import BookEarningCalculator from './BookEarningCalculator';

import Speech from "speak-tts";
// import adImage from '../../assets/pageimages/bookshelflistad.png';

const BookShelfListComponent = () => {
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();
    const [fetchData, { loading }] = useFetch();

    const [userId, setUserId] = useState(authState.user._id);
    const [ownerId, setownerId] = useState(authState.user._id);
    const [ownerName, setownerName] = useState(authState.user.name);
    const [myUserCode, setMyUserCode] = useState(authState.user.think5whyscode);
    const [userLevel, setUserLevel] = useState(0);
    const [atLevel, setAtLevel] = useState(0);

    const [bookId, setBookId] = useState(null);
    const [myBooks, setMyBooks] = useState([]);
    const [numberOfBooks, setNumberOfBooks] = useState([]);
    const [readLogs, setReadLogs] = useState([]);
    const [selectedBookId, setSelectedBookId] = useState(null);
    const [selectedReferralBookId, setSelectedReferralBookId] = useState(null);
    const [selectedLangCode, setSelectedLangCode] = useState('en-US');

    const [selectedLog, setSelectedLog] = useState(null);
    const [speechPrefClicked, setSpeechPrefClicked] = useState(false);
    const [speechPref, setSpeechPref] = useState(false);
    const [flyOnTheWall, setFlyOnTheWall] = useState(false);
    const [expandedDates, setExpandedDates] = useState([]);
    const [myReferralsList, setMyReferralsList] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(0);
    const [myReferralsCount, setMyReferralsCount] = useState(0);
    const [downTheLineGetAllCountClicked, setDownTheLineGetAllCountClicked] = useState(false);
    const [downTheLineGetYTDCountClicked, setDownTheLineGetYTDCountClicked] = useState(false);
    const [downTheLineGetMTDCountClicked, setDownTheLineGetMTDCountClicked] = useState(false);
    const [downTheLineGetLastSevenDaysCountClicked, setDownTheLineGetLastSevenDaysCountClicked] = useState(false);
    const [downTheLineGetTodayCountClicked, setDownTheLineGetTodayCountClicked] = useState(false);
    const [downTheLineGetCustomCountClicked, setDownTheLineGetCustomCountClicked] = useState(false);
    const [isOverlayVisible, setIsOverlayVisible] = useState(false);
    const [selectedThumbBook, setSelectedThumbBook] = useState(null);
    const [newReferEmailId, setNewReferEmailId] = useState('');
    const [newReferContactNumber, setNewReferContactNumber] = useState('');

    const [newReferClicked, setNewReferClicked] = useState(false);
    
    const [downTheLineGetCount, setDownTheLineGetCount] = useState({
        l1: { count: 0, totalCom: 0 },
        l2: { count: 0, totalCom: 0 },
        l3: { count: 0, totalCom: 0 },
        l4: { count: 0, totalCom: 0 },
        l5: { count: 0, totalCom: 0 },
        l6: { count: 0, totalCom: 0 },
        l7: { count: 0, totalCom: 0 },
        l8: { count: 0, totalCom: 0 }
    });
    
    const languageOptions = [
      { code: "en-US", name: "English (United States)" },
      { code: "en-GB", name: "English (United Kingdom)" },
      { code: "en-AU", name: "English (Australia)" },
      { code: "en-CA", name: "English (Canada)" },
      { code: "fr-FR", name: "French (France)" },
      { code: "fr-CA", name: "French (Canada)" },
      { code: "es-ES", name: "Spanish (Spain)" },
      { code: "es-MX", name: "Spanish (Mexico)" },
      { code: "de-DE", name: "German (Germany)" },
      { code: "it-IT", name: "Italian (Italy)" },
      { code: "pt-BR", name: "Portuguese (Brazil)" },
      { code: "pt-PT", name: "Portuguese (Portugal)" },
      { code: "ru-RU", name: "Russian (Russia)" },
      { code: "ja-JP", name: "Japanese (Japan)" },
      { code: "zh-CN", name: "Chinese (Simplified, China)" },
      { code: "zh-TW", name: "Chinese (Traditional, Taiwan)" },
      { code: "ko-KR", name: "Korean (South Korea)" },
      { code: "nl-NL", name: "Dutch (Netherlands)" },
      { code: "sv-SE", name: "Swedish (Sweden)" },
      { code: "no-NO", name: "Norwegian (Norway)" },
      { code: "da-DK", name: "Danish (Denmark)" },
      { code: "fi-FI", name: "Finnish (Finland)" },
      { code: "ar-SA", name: "Arabic (Saudi Arabia)" },
      { code: "hi-IN", name: "Hindi (India)" },
      { code: "bn-BD", name: "Bengali (Bangladesh)" },
      { code: "ta-IN", name: "Tamil (India)" },
      { code: "te-IN", name: "Telugu (India)" },
      { code: "ur-PK", name: "Urdu (Pakistan)" },
      { code: "tr-TR", name: "Turkish (Turkey)" },
      { code: "el-GR", name: "Greek (Greece)" },
    ];
  
    const [showTree, setShowTree] = useState(false);
    const [tree, setTree] = useState(null);
    const [totalUsers, setTotalUsers] = useState(0);
    const [showTable, setShowTable] = useState(false);
    const [postCommentClicked, setPostCommentClicked] = useState(false);
    const [postedComment, setPostedComment] = useState(false);
    const [postedCommentMsg, setPostedCommentMsg] = useState("");
    const [postMyCommentClicked, setPostMyCommentClicked] = useState(false);
    const [commentListFetched, setCommentListFetched] = useState(false);
    const [commentData, setCommentData] = useState([]);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [bookIdForComment, setBookIdForComment] = useState("");
    const [bookTitleForComment, setBookTitleForComment] = useState("");
    const [bookUserIdForComment, setBookUserIdForComment] = useState("");
    const [userCommentTitle, setUserCommentTitle] = useState("");
    const [userCommentDetails, setUserCommentDetails] = useState("");
    const [isVisibleToAllChecked, setIsVisibleToAllChecked] = useState(false);
    const [postToBeDisabled, setPostToBeDisabled] = useState(false);
    const [readCommentClicked, setReadCommentClicked] = useState(false);
    const [postCloseClicked, setPostCloseClicked] = useState(false);
    const [readCommentCloseClicked, setReadCommentCloseClicked] = useState(false);
    const [isImportantChecked, setIsImportantChecked] = useState(false);
    const [errors, setErrors] = useState();
    const [myPageWalletCount, setMyPageWalletCount] = useState(0);
    const [myAllPageReadCount, setMyAllPageReadCount] = useState(0);
    const [myAllBookPageCount, setMyAllBookPageCount] = useState(0);

const fetchMyBooks = useCallback(() => {
    const config = {
        url: "/mybooks",
        method: "get",
        headers: { Authorization: authState.token },
    };

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            if (response && Array.isArray(response.mybooks)) {
                setMyBooks(response.mybooks);
                setNumberOfBooks(myBooks.length);
            } else {
                console.error("Invalid response format: Book not found in response");
            }
        })
        .catch(error => {
            console.error("Error fetching MyBooks:", error);
        });
  }, [authState.token, fetchData]);


  useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchMyBooks();
  }, [authState.isLoggedIn, fetchMyBooks]);

    const formatDate = (date) => {
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatDateTime = (date) => {
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
        };
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const hours = jsDate.getHours().toString().padStart(2, '0');
        const minutes = jsDate.getMinutes().toString().padStart(2, '0');
        const seconds = jsDate.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    // const formatReadTime = (milliseconds) => {
    //     const totalSeconds = Math.floor(milliseconds / 1000);
    //     const minutes = Math.floor(totalSeconds / 60);
    //     const seconds = totalSeconds % 60;
    //     return `${minutes}:${seconds}`;
    // };

    const formatReadTime = (milliseconds) => {
      if (!milliseconds || isNaN(milliseconds)) return "0:00:00";

      const totalSeconds = Math.floor(milliseconds / 1000);

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      // Pad minutes & seconds to always show 2 digits
      const paddedMinutes = String(minutes).padStart(2, "0");
      const paddedSeconds = String(seconds).padStart(2, "0");

      return `${hours}:${paddedMinutes}:${paddedSeconds}`;
    };

    const handleReadClick = (bookCode, bookMasterId, bookCollectionName, lastPageRead, bookPages, bookIsChildren) => {
      if( bookCode === "ThinkNoteFlex")  {
        navigate('/readnoteflex', { state: { bookId: bookCode, bookMasterId: bookMasterId, bookCollectionName: bookCollectionName, lastPageRead: lastPageRead, bookPages: bookPages, isChildren: bookIsChildren } });
      } else if ( bookCode === "CAFE") {
        navigate('/readcafebook', { state: { bookId: bookCode, bookMasterId: bookMasterId, bookCollectionName: bookCollectionName, lastPageRead: lastPageRead, bookPages: bookPages, isChildren: bookIsChildren } });
      } else if ( bookCode === "MOBook") {
        navigate('/readopentextbook', { state: { bookId: bookCode, bookMasterId: bookMasterId, bookCollectionName: bookCollectionName, lastPageRead: lastPageRead, bookPages: bookPages, isChildren: bookIsChildren } });
      } 
      else {
        navigate('/readbook', { state: { bookId: bookCode, bookMasterId: bookMasterId, bookCollectionName: bookCollectionName, lastPageRead: lastPageRead, bookPages: bookPages, isChildren: bookIsChildren } });
      }
    };

    const [viewReadLogClicked, setViewReadLogClicked] = useState(false);
    const handleReadLogClick = (bookId) => {
        setSelectedBookId(prev => (prev === bookId ? null : bookId));
        setViewReadLogClicked(!viewReadLogClicked);
        fetchReadingLog(bookId);
    };

    useEffect(() => {
    }, [selectedBookId]);

    const [viewNotes, setViewNotes] = useState(false);
    const handleViewNotesClick = (bookId) => {
      setSelectedBookId(prev => (prev === bookId ? null : bookId));
      setViewNotes(true);
      setViewReadLogClicked(false);
      if(viewReadLogClicked && readLogs.length<1) {
        fetchReadingLog(bookId);
      }
  };

  const [instantReferralViewClicked,setInstantReferralViewClicked]=useState(false);
  const [myBBList,setMyBBList]=useState(false);
  const [numberOfBB,setNumberOfBB]=useState(0);

  const handleInstantReferralsListClick = (bookId) => {
    setInstantReferralViewClicked(!instantReferralViewClicked);
    if(!instantReferralViewClicked) {
      return;
    }
    if(numberOfBB < 1)
    {
      fetchMyInstantReferral(bookId);
    }
  };

  const fetchMyInstantReferral = useCallback((bookId) => {
    const config = {
        url: "/mybooks/mybblist",
        method: "post",
        headers: { Authorization: authState.token },
        data: {bookId: bookId, bbId: userId}
    };

    fetchData(config, { showSuccessToast: false })
        .then(response => {
            if (response && Array.isArray(response.myBBList)) {
                setMyBBList(response.myBBList);
                setNumberOfBB(myBBList.length);
            } else {
                console.error("Invalid response format: Book not found in response");
            }
        })
        .catch(error => {
            console.error("Error fetching MyBooks:", error);
        });
  }, [authState.token, fetchData]);


  useEffect(() => {
      if (!authState.isLoggedIn) return;
      fetchMyInstantReferral();
  }, [authState.isLoggedIn, fetchMyInstantReferral]);


const [viewBillClicked,setViewBillClicked]=useState(false);
const [myInvoice,setMyInvoice]=useState('');

const handleViewBillClick = (mybookId) => {
  setViewBillClicked(prev => !prev);
  
  if (!myInvoice) {
    fetchMyInvoice(mybookId);
  }
};

const fetchMyInvoice = useCallback((mybookId) => {
  const config = {
      url: "/myorders/invoice",
      method: "post",
      headers: { Authorization: authState.token },
      data: { bookId: mybookId, userId: userId }
  };

  fetchData(config, { showSuccessToast: false })
      .then(response => {
          if (response && response.myInvoice) {
              setMyInvoice(response.myInvoice);  
          } else {
              setMyInvoice('');  
              console.error("Invalid response format: Invoice not found in response");
          }
      })
      .catch(error => {
          setMyInvoice('');  
          console.error("Error fetching invoice:", error);
      });
}, [authState.token, fetchData, userId]);

    const handleFlyOnTheWallClick = (bookId, bookTitle) => {
        navigate('/flyonwall/add', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, flyerOnTheWallId: null, flyerOnTheWallName: null } });
    };

    const handleFlyerOnTheWallListClick = (bookId, bookTitle) => {
        navigate('/flyersonthewall', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, fromPage: "bookShelfList" } });
    };

    const handleDcrClick = (bookId, bookTitle) => {
        navigate('/dcr/add', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, coReaderId: null, coReaderName: null } });
    };

    const handleDcrListClick = (bookId, bookTitle) => {
        navigate('/dcrlist', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, fromPage: "bookShelfList" } });
    };

    const fetchReadingLog = useCallback((bookId) => {
        setBookId(bookId);
        const config = {
            url: "/myreadinglog",
            method: "get",
            headers: { Authorization: authState.token },
            params: { bookId: bookId, userId: userId }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response)) {
                    setReadLogs(response);
                    setSelectedLog(bookId);
                    setViewReadLogClicked(true);
                } else {
                    console.error("Invalid response format: Book reading log not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching BooksReadingLog:", error);
            });
    }, [authState.token, fetchData, userId, bookId]);

    useEffect(() => {
        fetchReadingLog(bookId);
    }, [fetchReadingLog, setReadLogs]);


    useEffect(() => {

    }, [readLogs, bookId], selectedLog);

    const [showReferralsList, setShowReferralsList] = useState(false);

    const handleMyReferralsListClick = (bookId, myUserCode, userLevel) => {
        setSelectedReferralBookId(prev => (prev === bookId ? null : bookId));
        setSelectedBookId(bookId);
        setShowReferralsList(!showReferralsList);
        fetchMyReferralsList(bookId, myUserCode, userLevel);
    };

    const fetchMyReferralsList = useCallback((bookId, myUserCode, userLevel) => {
        setBookId(bookId);
        setMyUserCode(myUserCode);
        setUserLevel(userLevel);
        const config = {
            url: "/mybooks/mydirectreferralslist",
            method: "post",
            headers: { Authorization: authState.token },
            data: { bookId: bookId, advisorCode: myUserCode, userCode: myUserCode }
        };

        fetchData(config)
            .then(response => {
                if (response && response.referralsList && Array.isArray(response.referralsList)) {
                    setMyReferralsList(response.referralsList);
                } else {
                    console.error("Invalid response format: Referral List not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Referral List:", error);
            });
    }, [authState.token, fetchData, userId, bookId]);

    useEffect(() => {
  
    }, [fetchMyReferralsList, setMyReferralsList]);

    const fetchMyReferralsCount = useCallback((bookId, myUserCode, userLevel, atLevel) => {
        setBookId(bookId);
        setMyUserCode(myUserCode);
        setAtLevel(atLevel);
        const config = {
            url: "/mybooks/myreferralscount",
            method: "post",
            headers: { Authorization: authState.token },
            data: { bookId: bookId, advisorCode: myUserCode, userLevel: userLevel, atLevel: atLevel }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response) {
                    setMyReferralsCount(response.referralsCount);
                    setSelectedLevel(atLevel);
                } else {
                    console.error("Invalid response format: Referral Count not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Referral Count:", error);
            });
    }, [authState.token, fetchData, userId, bookId, myUserCode, userLevel, atLevel]);

    useEffect(() => {

    }, [fetchMyReferralsCount, setMyReferralsCount]);


    useEffect(() => {
        //
    }, [myReferralsCount, bookId], myUserCode, atLevel, selectedLevel);

    const dateRangeType='A';
    const [fromDate, setFromDate] = useState(new Date().toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
    const [customFromDate, setCustomFromDate] = useState(new Date().toISOString().split('T')[0]);
    const [customToDate, setCustomToDate] = useState(new Date().toISOString().split('T')[0]);

    const handleChange = (e) => {
      const { name, value } = e.target;
      if (name === 'newReferContactNumber') {
        setNewReferContactNumber(value);
      } else if (name === 'newReferEmailId') {
        setNewReferEmailId(value);
      }
    };

    const fieldError = (fieldName) => {
      if (fieldName === 'newReferEmailId' && !newReferEmailId.includes('@')) {
        return <p className="text-red-500">Please enter a valid email address</p>;
      }
      if (fieldName === 'newReferContactNumber' && newReferContactNumber.length < 10) {
        return <p className="text-red-500">Please enter a valid WhatsApp number</p>;
      }
      return null; // No error
    };

    const handleNewRefer = () => {
      setNewReferClicked(true);
    };

    const handleNewReferSent = (bookId, newReferContactNumber, newReferEmailId) => {
      handleWhatsAppClick(bookId, newReferContactNumber, newReferEmailId);
    };

    // WhatsApp method for referral
    const handleWhatsAppClick = (bookId, newReferContactNumber, newReferEmailId) => {
      const whatsappUrl = `https://wa.me/${newReferContactNumber}?text=Check%20out%20this%20book!%20Book%20ID:%20${bookId}%20Email:%20${newReferEmailId}`;
      window.open(whatsappUrl, '_blank');
    };

    const fetchDownTheLineGetCount = useCallback((selectedBookId, myUserCode, myUserId, dateRangeType, fromDate, toDate) => {
        setBookId(selectedBookId);
        setMyUserCode(myUserCode);
        if (!selectedBookId || !myUserCode || !myUserId || !dateRangeType || !fromDate || !toDate) {
            return;
        }
        const config = {
            url: "/mlmchart/downthelinecount",
            method: "post",
            headers: { Authorization: authState.token },
            data: { 
                bookId: selectedBookId, 
                userCode: myUserCode, 
                userId: myUserId, 
                dateRangeType: dateRangeType, 
                fromDate: fromDate,
                toDate: toDate 
            }
        };
        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && response.referralsCount) {
                    setDownTheLineGetCount(response.referralsCount);
                } else {
                    console.error("Invalid response format: Down The Line Referral Count not found in response");
                    setDownTheLineGetCount({
                        l1: { count: 0, totalCom: 0 },
                        l2: { count: 0, totalCom: 0 },
                        l3: { count: 0, totalCom: 0 },
                        l4: { count: 0, totalCom: 0 },
                        l5: { count: 0, totalCom: 0 },
                        l6: { count: 0, totalCom: 0 },
                        l7: { count: 0, totalCom: 0 },
                        l8: { count: 0, totalCom: 0 }
                    });
                }
            })
            .catch(error => {
                console.error("Error fetching Down The Line  Referral Count:", error);
                setDownTheLineGetCount({
                    l1: { count: 0, totalCom: 0 },
                    l2: { count: 0, totalCom: 0 },
                    l3: { count: 0, totalCom: 0 },
                    l4: { count: 0, totalCom: 0 },
                    l5: { count: 0, totalCom: 0 },
                    l6: { count: 0, totalCom: 0 },
                    l7: { count: 0, totalCom: 0 },
                    l8: { count: 0, totalCom: 0 }
                });
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
    }, [setDownTheLineGetCount, fetchDownTheLineGetCount]);

    const [downTheLineReferralsDataClicked, setdownTheLineReferralsDataClicked] = useState(false);
    const [downTheLineReferralsList, setDownTheLineReferralsList] = useState([]);

    const handleGetDownTheLineReferralList = (selectedBookId) => {
        // setSelectedBookId(prev => (prev === selectedBookId ? null : selectedBookId));
        setdownTheLineReferralsDataClicked(true);
        const fromDate = new Date().toISOString().split('T')[0];;
        const toDate = new Date().toISOString().split('T')[0];;
        fetchDownTheLineReferralsList(selectedBookId, myUserCode, userId, 'A', fromDate, toDate);
    };

    const fetchDownTheLineReferralsList = useCallback((selectedBookId, myUserCode, myUserId, dateRangeType, fromDate, toDate) => {
        setBookId(selectedBookId);
        setMyUserCode(myUserCode);
        if (!selectedBookId || !myUserCode || !myUserId || !dateRangeType || !fromDate || !toDate) {
            return;
        }
        const config = {
            url: "/mlmchart/downthelinereferralslist",
            method: "post",
            headers: { Authorization: authState.token },
            data: { 
                bookId: selectedBookId, 
                userCode: myUserCode, 
                userId: myUserId, 
            }
        };
        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && response.referralsList) {
                    setDownTheLineReferralsList(response.referralsList);
                } else {
                    console.error("Invalid response format: Down The Line Referrals not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Down The Line  Referral Count:", error);
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
    }, [setDownTheLineReferralsList, fetchDownTheLineReferralsList]);

    // const aggregatedLevels = useMemo(() => {
    //   const levels = {};

    //   downTheLineReferralsList.forEach((item) => {
    //     const level = item.matchedLevel;

    //     if (!levels[level]) {
    //       levels[level] = { count: 0, totalCom: 0 };
    //     }

    //     levels[level].count += 1;
    //     levels[level].totalCom += item.commissionEarned || 0;
    //   });

    //   return levels;
    // }, [downTheLineReferralsList]);

    const [selectedPeriod, setSelectedPeriod] = useState("Lifetime");
    const periodOptions = [
      "Lifetime",
      "Today",
      "Yesterday",
      "Current Week",
      "Current Month",
      "Current Quarter",
      "Current Year",
      "Custom Date Range",
    ];

    const getDateRange = (period) => {
      const now = new Date();
      let start = new Date();
      let end = new Date();

      switch (period) {
        case "Today":
          start = new Date(now.setHours(0, 0, 0, 0));
          break;

        case "Yesterday":
          start = new Date(now);
          start.setDate(start.getDate() - 1);
          start.setHours(0, 0, 0, 0);
          end = new Date(start);
          end.setHours(23, 59, 59, 999);
          break;

        case "Current Week":
          const day = now.getDay();
          start = new Date(now);
          start.setDate(now.getDate() - day);
          start.setHours(0, 0, 0, 0);
          break;

        case "Current Month":
          start = new Date(now.getFullYear(), now.getMonth(), 1);
          break;

        case "Current Quarter":
          const quarter = Math.floor(now.getMonth() / 3);
          start = new Date(now.getFullYear(), quarter * 3, 1);
          break;

        case "Current Year":
          start = new Date(now.getFullYear(), 0, 1);
          break;

        case "Lifetime":
          return { start: null, end: null };

        case "Custom Date Range":
          return {
            start: fromDate ? new Date(fromDate) : null,
            end: toDate ? new Date(toDate) : null,
          };

        default:
          return { start: null, end: null };
      }

      return { start, end };
    };

    const filteredList = useMemo(() => {
      if (!downTheLineReferralsList) return [];

      const { start, end } = getDateRange(selectedPeriod);

      return downTheLineReferralsList.filter((item) => {
        const itemDate = new Date(item.bookBuyDate);

        // 🔹 Date filter
        let isDateValid = true;
        if (start && end) {
          isDateValid = itemDate >= start && itemDate <= end;
        } else if (start) {
          isDateValid = itemDate >= start;
        }

        // 🔹 Level filter
        let isLevelValid = true;
        if (selectedLevel !== "All") {
          isLevelValid = item.matchedLevel === Number(selectedLevel);
        }

        return isDateValid && isLevelValid;
      });
    }, [downTheLineReferralsList, selectedPeriod, selectedLevel, fromDate, toDate]);

    const aggregatedLevels = useMemo(() => {
      const levels = {};

      filteredList.forEach((item) => {
        const level = item.matchedLevel;

        if (!levels[level]) {
          levels[level] = { count: 0, totalCom: 0 };
        }

        levels[level].count += 1;
        levels[level].totalCom += item.commissionEarned || 0;
      });

      return levels;
    }, [filteredList]);

    // const [selectedLevel, setSelectedLevel] = useState("All");
    // const [fromDate, setFromDate] = useState("");
    // const [toDate, setToDate] = useState("");



    const handleDownTheLineGetAllCount = (selectedBookId) => {
        setDownTheLineGetAllCountClicked(true);
        const fromDate = new Date().toISOString().split('T')[0];;
        const toDate = new Date().toISOString().split('T')[0];;
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'A', fromDate, toDate);
    };

    const handleDownTheLineGetYTDCount = (selectedBookId) => {
        setDownTheLineGetYTDCountClicked(true);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; 

        const firstDateOfYear = new Date(today.getFullYear(), 0, 1); 
        const fromDate = firstDateOfYear.toISOString().split('T')[0];
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'Y', fromDate, toDate);
    };

    const handleDownTheLineGetMTDCount = (selectedBookId) => {
        setDownTheLineGetMTDCountClicked(true);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; 

        const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const fromDate = firstDateOfMonth.toISOString().split('T')[0]; 
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'M', fromDate, toDate);
    };

    const handleDownTheLineGetLastSevenDaysCount = (selectedBookId) => {
        setDownTheLineGetLastSevenDaysCountClicked(true);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; 
        const sixDaysAgo = new Date(yesterday);
        sixDaysAgo.setDate(sixDaysAgo.getDate() - 6);
        const fromDate = sixDaysAgo.toISOString().split('T')[0]; 
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'W', fromDate, toDate);
    };

    const handleDownTheLineGetTodayCount = (selectedBookId) => {
        setDownTheLineGetTodayCountClicked(true);
        const fromDate = new Date().toISOString().split('T')[0];
        const toDate = new Date().toISOString().split('T')[0];
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'T', fromDate, toDate);
    };

    const handleDownTheLineGetCustomCount = (selectedBookId) => {
        setDownTheLineGetCustomCountClicked(true);
        const fromDate = customFromDate;
        const toDate = customToDate;
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'C', fromDate, toDate);
    };

    const sortedBooks = myBooks.sort((a, b) => {
        const dateA = new Date(a.purchaseDate);
        const dateB = new Date(b.purchaseDate);
        return dateB - dateA;
    });


    const sortedLog = readLogs.sort((a, b) => {
        const dateA = new Date(a.dateRead);
        const dateB = new Date(b.dateRead);
        return dateB - dateA;
    });

    const sortedPages = readLogs.sort((a, b) => {
      const pageA = new Date(a.pageNumber);
      const pageB = new Date(b.pageNumber);
      return pageA - pageB;
  });

    const toggleDateExpansion = (date) => {
        if (expandedDates.includes(date)) {
            setExpandedDates(expandedDates.filter(item => item !== date));
        } else {
            setExpandedDates([...expandedDates, date]);
        }
    };

  const logsByDate = readLogs.reduce((acc, log) => {
      const date = log.dateRead.split('T')[0];
      if (!acc[date]) {
          acc[date] = [];
      }
      acc[date].push(log);
      return acc;
  }, {});

  const sortedLogsByDate = Object.keys(logsByDate)
      .sort((a, b) => new Date(b) - new Date(a))
      .reduce((acc, date) => {
          acc[date] = logsByDate[date];
          return acc;
  }, {});

  const getDateRangeInfo = (readLogs) => {
    if (!readLogs || readLogs.length === 0) {
      return {
        totalDays: 0,
        firstDate: null,
        lastDate: null,
      };
    }

    const timestamps = readLogs.map(log => new Date(log.dateRead).getTime());

    const minDate = new Date(Math.min(...timestamps));
    const maxDate = new Date(Math.max(...timestamps));

    // Normalize to start of day
    const start = new Date(minDate);
    const end = new Date(maxDate);

    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);

    const diffTime = end - start;
    const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24)) + 1;

    return {
      totalDays,
      firstDate: start,
      lastDate: end,
    };
  };

  const groupedReadLogs = Object.values(
    readLogs.reduce((acc, log) => {
      const pageNumber = Number(log.pageNumber);

      if (!acc[pageNumber]) {
        acc[pageNumber] = {
          pageNumber,
          pageCount: 0,
          totalMilliseconds: 0,
          readingRemarks: [],
        };
      }

      acc[pageNumber].pageCount += 1;
      acc[pageNumber].totalMilliseconds += Number(log.readTimeInMiliseconds || 0);

      if (
        log.readingRemarks &&
        !acc[pageNumber].readingRemarks.includes(log.readingRemarks)
      ) {
        acc[pageNumber].readingRemarks.push(log.readingRemarks);
      }

      return acc;
    }, {})
  );
    
  const totalStats = groupedReadLogs.reduce(
    (acc, group) => {
      acc.totalReadCount += group.pageCount;
      acc.totalTime += group.totalMilliseconds;
      return acc;
    },
    {
      totalReadCount: 0,
      totalTime: 0,
    }
  );

  const { totalDays, firstDate, lastDate } = getDateRangeInfo(readLogs);

  const totalCount = Object.values(downTheLineGetCount).reduce((sum, level) => sum + level.count, 0);
  const totalCommission = Object.values(downTheLineGetCount).reduce((sum, level) => sum + parseFloat(level.totalCom), 0);

  const [showReferrals, setShowReferrals] = useState(false);

  const toggleReferralsList = () => {
    setShowReferrals(!showReferrals);
  };

  const [viewCommentClick, setViewCommentClick] = useState(false);
  const [viewCommentClickMsg, setViewCommentClickMsg] = useState('');
  const handleViewComments = (selectedBookId, bookOwnerId, bookPageNumber) => {
    setIsOverlayVisible(true);
    fetchReadCommentByPageNumber(selectedBookId, bookOwnerId, bookPageNumber);
  }

  const handleCloseOverlay = () => {
    setIsOverlayVisible(false);
  };
  
  const fetchReadCommentByPageNumber = useCallback((selectedBookId, bookOwnerId, bookPageNumber) => {
    const config = {
      url: "/myreadingnotes/notesbybookpage",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookId: selectedBookId,
        userId: bookOwnerId,
        pageNumber: bookPageNumber
      },
    };

    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        if (response && response.status) {
          setCommentData(response.notes);
        } else {
          console.error("Read Comments data not found in response");
        }
      })
      .catch((error) => {
        console.error("Error fetching Read Comments data:", error);
      });
  }, [authState.token, fetchData]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchReadCommentByPageNumber();
  }, [authState.isLoggedIn, fetchReadCommentByPageNumber]);

  const sortedCommentData = [...commentData].sort(
    (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
  );

  const handlePostClose = () => {
    setPostCloseClicked(true);
    setPostCommentClicked(false);
    setPostToBeDisabled(true);
  };

  const handleReadCommentClose = () => {
    setReadCommentClicked(false);
    setReadCommentCloseClicked(true);
  };

  const gotoRCA = (bookIdForComment, bookTitleForComment, userIdForComment, pageNumber ) => {
    navigate("/rcas/add");
  };

  const [isListenNotesClicked, setIsListenNotesClicked] = useState(false);
  
  const listenNotesClicked = (mynotestext) => {
    setIsListenNotesClicked(true);
    speech.cancel();
    toggleSpeechNotes(mynotestext);
  }

  const [isNotesSpeaking, setIsNotesSpeaking] = useState(false);
  const speech = new Speech();

  const toggleSpeechNotes = (mynotestext) => {
    if (isNotesSpeaking) {
      speech.cancel();
      setIsNotesSpeaking(false);
    } else {
      setIsNotesSpeaking(true);
      speech.setRate(1.0);
      speech.setPitch(2.0);
      speech.setVolume(1.0);
      speech.setLanguage(selectedLangCode);
      speech.speak({ text: mynotestext });
    }
  };

  useEffect(() => {
    return () => {
      if (isNotesSpeaking) {
        speech.cancel();
        setIsNotesSpeaking(false);
      }
    };
  }, [isNotesSpeaking]);

const handleViewGraphTimeLineClick = (graphData) => {
    navigate("/bigdata-book-readlog-timeline", { state: { graphData: graphData } });
};

const handleViewGraphPageReadCountClick = (graphData) => {
  navigate("/bigdata-book-readlog-pageread", { state: { graphData: graphData } });
};

const scrollToDetail = (bookCode) => {
  const detailElement = document.getElementById(`book-detail-${bookCode}`);
  if (detailElement) {
    detailElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    console.error(`Detail section for bookCode ${bookCode} not found.`);
  }
};

  return (
    <div className="flex flex-col justify-center text-white [&_p]:text-white">
      <div className="ml-2 mr-2 page-content flex flex-col justify-center items-center">
        <>
          {myBooks.length < 1 ? (
            <div className="text-yellow-200 text-2xl lg:text-4xl mt-2">
              <p>Your Bookshelf is Empty!!</p>
            </div>
          ) : (
            <div>
              <p className="text-white text-xl">Your BookShelf has {myBooks.length} Titles</p>
            </div>
          )}
        </>
      </div>

      <div className="p-2 grid grid-cols-3 lg:grid-cols-8 gap-1 place-items-center">
        {sortedBooks.map((book, index) => (
          <div
            key={book.bookCode}
            className="flex flex-col items-center p-2 h-60 lg:h-72 w-40 bg-black border border-blue-400"
            onClick={() => scrollToDetail(book.bookCode)}
            style={{ cursor: 'pointer' }}
          >
            <img 
                src={`/api/bookworldthumb/${book.bookImage}.png`}
                alt={"No Image " + book.bookTitle} 
                className="thumb-book-image"
            />
            <h2 className="flex flex-col text-center p-2 text-xs lg:text-sm text-white">
              {book.isCollection ? <span className="text-yellow-200">Collection: </span> : ""}
              {book.bookTitle}
            </h2>
          </div>
        ))}
      </div>
      {sortedBooks.map((book, index) => (
        <div key={book.bookCode} id={`book-detail-${book.bookCode}`} className="bg-black flex flex-col items-center justify-center border border-blue-400 p-4">
          <div>
            <h2 className="text-yellow-200">Title - # {index + 1}</h2>
          </div>
          {book.isCollection && (
          <div className="mt-2 p-2">
            <h2 className="book-title text-green-700">
              This is part of{" "}
              <span className="text-green-700">
                {book.collectionTitle} Collection of Books
              </span>
            </h2>
          </div>
          )}
          {book.isCollection === true && (
            <div>
              <p className="text-purple-300">
                This is a collection. You can't read a collection directly. In
                stead read the books of this collection available in your
                BookShelf.
              </p>
            </div>
          )}
          <div className="thumb-book-image-container">
            <img 
                src={`/api/bookworldthumb/${book.bookImage}.png`}
                alt={"No Image " + book.bookTitle} 
                className="thumb-book-image w-full h-48 object-cover rounded-md"
            />
          </div>
          <div className="mt-2">
            <p className="text-white">{book.bookTitle}</p>
          </div>
          {book.isSampleBuy && (
            <div>
              <p className="bg-yellow-200 text-cyan-300">
                This is Sample. Limited access is applied on this.
              </p>
            </div>
          )}
          <div className="mt-2 mb-2 w-full">
            <div className="flex justify-center mt-2">
              <div className="tooltip-container w-20">
                <button
                  className="ml-4 px-2 py-1 text-white rounded bg-green-500"
                  disabled={book.isCollection}
                  onClick={() =>
                    handleReadClick(
                      book.bookCode,
                      book.bookId,
                      book.bookCollectionName,
                      book.lastPageRead,
                      book.bookPages,
                      book.isChildren
                    )
                  }
                  style={{ maxWidth: "150px" }}
                >
                  <FontAwesomeIcon icon={faBookOpen} />
                </button>
                <span className="tooltip">Read</span>
              </div>
              <div className="tooltip-container ml-4 w-20">
                <button
                  className="ml-2 py-1 text-white rounded bg-green-500"
                  disabled={book.isCollection}
                  onClick={() => handleReadLogClick(book.bookId)}
                  style={{ maxWidth: "160px" }}
                >
                  <FontAwesomeIcon icon={faBook} />
                </button>
                <span className="tooltip">View Read Log</span>
              </div>
              <div className="tooltip-container ml-4 w-20">
                <button
                  className="ml-2 py-1 text-white rounded bg-green-500"
                  disabled={book.isCollection || !viewReadLogClicked}
                  onClick={() => handleViewNotesClick(book.bookId)}
                  style={{ maxWidth: "160px" }}
                >
                  <FontAwesomeIcon icon={faComment} />
                </button>
                <span className="tooltip">View / Listen Notes</span>
              </div>
              <div className="tooltip-container ml-4 w-20">
                  <button
                    className="ml-2 py-1 text-white rounded bg-green-500"
                    onClick={() => handleViewGraphTimeLineClick(sortedLogsByDate)}
                    disabled={!viewReadLogClicked}
                    style={{ maxWidth: "160px" }}
                  >
                    <FontAwesomeIcon icon={faBarChart} />
                  </button>
                  <span className="tooltip">View Graph</span>
              </div>
            </div>
            {selectedBookId === book.bookId &&
              Object.keys(sortedLogsByDate).length > 0 && book && (
                <div className='text-sm w-full'>
                  <div className='flex flex-col justify-center items-center'>
                    <p className='text-black'>
                      <span className="text-green-600 mr-2">
                        Page Accessed {readLogs.length} times!
                      </span>
                       
                      <span className='text-blue-700 ml-4'>
                        Your Paid Page Access Limit is {book.paidReads}!
                      </span>
                    </p>
                    { readLogs.length > (book.paidReads + myPageWalletCount) && (
                      <>
                        <p className='text-yellow-200'>Your Page Read Limit has Reached
                          <span className='ml-2'>
                            <Link to="/genai-price-List" className='text-orange-300'>
                              Buy Topup Subscription
                            </Link>
                          </span>
                        </p>
                      </>
                    )}
                  </div>
                  <div className='flex flex-row justify-center mb-2'>
                    <p className="text-sm text-white">Time Spent in min:sec (less than 0 seconds will be shown as 0:0)</p>
                  </div>
                  { viewReadLogClicked && (
                    <>
                      <div className="text-white bg-slate-800 flex w-full text-lg">
                          <p className='text-yellow-200'>Page Access Log ({readLogs.length} times accessed)</p>
                      </div>
                      <div className="text-white bg-slate-700 flex w-full text-sm">
                        <div
                          className="text-sm"
                          style={{
                            width: "30%",
                            border: "1px solid white",
                            textAlign: "left",
                            padding: "0.25rem", 
                          }}
                        >
                          Date Read
                        </div>
                        <div
                          className="text-sm"
                          style={{
                            width: "50%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Page
                        </div>
                        <div
                          className="text-sm"
                          style={{
                            width: "20%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Time Spent
                        </div>
                      </div>
                      <div className="text-white bg-black w-full text-sm">
                        {Object.entries(sortedLogsByDate).map(([date, logs]) => (
                          <div key={date}>
                            <div
                              className="text-yellow-200 text-sm"
                              onClick={() => toggleDateExpansion(date)}
                              style={{ textAlign: "left" }}
                            >
                              <span>
                                {expandedDates.includes(date) ? "-" : "+"}
                              </span>{" "}
                              {formatDate(date)}
                            </div>
                            {expandedDates.includes(date) && (
                              <div className='text-sm mt-2'>
                                {logs.map((log, index) => (
                                  <div
                                    key={index}
                                    className="flex justify-start text-sm"
                                  >
                                    <div
                                      className='text-sm px-2'
                                      style={{
                                        width: "30%",
                                        marginRight: "2px",
                                        border: "1px solid white",
                                      }}
                                    >
                                      {formatDateTime(log.dateRead)}
                                    </div>
                                    <div
                                      style={{
                                        width: "50%",
                                        marginRight: "2px",
                                        border: "1px solid white",
                                      }}
                                      className='px-2'
                                    >
                                      {log.readingMode==='TV' && ( <FontAwesomeIcon className="text-sm mr-2" icon={faTv}/>)}
                                      {log.readingRemarks}
                                    </div>
                                    <div
                                      style={{
                                        width: "20%",
                                        border: "1px solid white",
                                      }}
                                      className='px-2'
                                    >
                                      {formatReadTime(log.readTimeInMiliseconds)}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    </>
                  )} 
                  { viewNotes && (
                    <>
                      <div className="text-white bg-slate-800 flex w-full text-lg mt-4">
                          <p>Pages Access Summary, Notes & RCA</p>
                      </div>
                      <div className="text-white bg-slate-800 mt-2 px-2 py-1 text-sm">
                        In <strong>{totalDays}</strong> days from{" "}
                        <strong>{formatDate(firstDate)}</strong> to{" "}
                        <strong>{formatDate(lastDate)}</strong>
                      </div>
                      <div className="flex bg-green-300 text-black font-semibold mt-2">
                        <div style={{ width: "40%", border: "1px solid white" }} className="px-2">
                          TOTAL
                        </div>
                        <div style={{ width: "15%", border: "1px solid white" }} className="px-2">
                          {totalStats.totalReadCount}
                        </div>
                        <div style={{ width: "15%", border: "1px solid white" }} className="px-2">
                          {formatReadTime(totalStats.totalTime)}
                        </div>
                        <div style={{ width: "15%", border: "1px solid white" }}></div>
                        <div style={{ width: "15%", border: "1px solid white" }}></div>
                      </div>
                      <div className="text-white bg-slate-700 px-2 flex w-full text-sm">
                        <div
                          className="text-sm"
                          style={{
                            width: "40%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Page
                        </div>
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Read Count
                        </div>
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Time Spent
                        </div>
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          Notes
                        </div> 
                        <div
                          className="text-sm"
                          style={{
                            width: "15%",
                            border: "1px solid white",
                            padding: "0.25rem", 
                          }}
                        >
                          RCA
                        </div>
                      </div>
                      <div className="text-black bg-blue-200 px-2 w-full text-sm">
                        {groupedReadLogs.map((group, index) => (
                          <div key={index} className="flex justify-start text-sm">
                            <div
                              style={{
                                width: "40%",
                                marginRight: "2px",
                                border: "1px solid white",
                              }}
                              className='px-2'
                            >
                              {group.readingMode==='TV' && ( <FontAwesomeIcon className="text-sm mr-2" icon={faTv}/>)}
                              {group.pageNumber}
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                              className='px-2'                              
                            >
                              {group.pageCount}
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                              className='px-2'
                            >
                              {formatReadTime(group.totalMilliseconds)}
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                            >
                              <Tooltip text={"View Notes/Comments"} position={"top"}>
                                <span
                                  className="mr-1 text-blue-500 cursor-pointer px-2"
                                  onClick={() =>
                                    handleViewComments(
                                      book.bookId,
                                      book.userId,
                                      group.pageNumber
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-comments"></i>
                                </span>
                              </Tooltip>
                            </div>
                            <div
                              style={{
                                width: "15%",
                                border: "1px solid white",
                              }}
                            >
                              <Tooltip text={"RCA"} position={"top"}>
                                <span
                                  className="ml-1 mr-1 text-blue-500 cursor-pointer px-2"
                                  onClick={() =>
                                    gotoRCA(
                                      book.bookId,
                                      book.bookTitle,
                                      book.ownerId,
                                      group.pageNumber
                                    )
                                  }
                                >
                                  <i className="fa-solid fa-fish"></i>
                                </span>
                              </Tooltip>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  {isOverlayVisible && (
                    <>
                    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-[1000[">
                      <div className="bg-black p-6 rounded-lg shadow-lg w-full">
                        <button
                          className="mt-4 right-2 bg-red-500 text-white w-32 h-12 flex items-center"
                          onClick={() => handleCloseOverlay(false)}
                        >
                          <FontAwesomeIcon icon={faTimes} />Close
                        </button>
                        {sortedCommentData.length > 0 ? (
                          sortedCommentData.map((commentItem, commentIndex) => (
                            <div
                              key={commentIndex}
                              className="mb-2 p-6 bg-black shadow-xl rounded-lg border border-gray-200 hover:shadow-2xl"
                            >
                              <h4 className="text-2xl font-bold text-white mb-2">
                                {commentItem.notesType}
                              </h4>
                              <p className="text-lg font-semibold text-blue-700 mb-2">
                                {commentItem.notesTitle}
                              </p>
                              <p className="text-base text-gray-200 mb-4">
                                <strong>Details:</strong>
                                <br />
                                {commentItem.notesText}
                              </p>
                              <div className="flex justify-between items-center">
                                <p className="text-sm text-gray-200">
                                  <strong>Is Important: </strong>
                                  {commentItem.isImportant ? (
                                    <span className="text-red-600 font-semibold">Yes</span>
                                  ) : (
                                    "No"
                                  )}
                                </p>
                                <p className="text-sm text-gray-200">
                                  <strong>By: </strong>
                                  {commentItem.notesBy}
                                </p>
                              </div>
                              <p className="text-right text-sm text-gray-200 mt-4">
                                <strong>Date: </strong>
                                {formatDateTime(commentItem.dateCreated)}
                              </p>
                              <div className="flex justify-end items-center mt-4">
                                <select
                                  value={selectedLangCode}
                                  onChange={(e) => setSelectedLangCode(e.target.value)}
                                  className="ml-4 p-2 h-8 border border-gray-300 rounded"
                                >
                                  {languageOptions.map((option) => (
                                    <option key={option.code} value={option.code}>
                                      {option.name}
                                    </option>
                                  ))}
                                </select>
                                <button
                                  className="ml-1 mt-2 mr-4 max-w-8 max-h-8 bg-green-600 text-white"
                                  onClick={() => listenNotesClicked(commentItem.notesText)}
                                >
                                  {isNotesSpeaking ? (
                                    <FontAwesomeIcon icon={faStop} />
                                  ) : (
                                    <FontAwesomeIcon icon={faPlay} />
                                  )}
                                </button>
                              </div>
                            </div>
                          ))
                        ) : (
                          <>
                          <div className="mt-20 mb-20 flex flex-col justify-center text-center">
                            <p className="text-lg font-medium text-orange-500">
                              There are no Notes / Comments / Remarks for this Page!
                            </p>
                            <button
                              className="mt-4 right-2 w-32 h-12 bg-red-500 text-white"
                              onClick={() => handleCloseOverlay(false)}
                            >
                              <FontAwesomeIcon icon={faTimes} />Close
                            </button>
                          </div>
                          </>
                        )}
                      </div>
                    </div>
                    </>
                  )}
                  {viewCommentClick && (
                    <div className="flex justify-center text-yellow-600 mb-4">
                      <p>{viewCommentClickMsg}</p>
                    </div>
                  )}
                </div>
              )}
            <div className='flex flex-col items-center justify-center'>
              <p className="book-author text-gray-200">
                Pages: {book.bookPages}
              </p>
              <p className="book-author text-gray-200">
                Author: {book.bookAuthor}
              </p>
              <p className="book-author text-gray-200">
                In BookShelf Since{" "}
                <strong>{formatDateTime(book.purchaseDate)}</strong>
              </p>
              {book.isCollection === false && (
                <>
                  <p
                    className={`book-author ${
                      book.lastReadingDate
                        ? "text-white"
                        : "text-gray-300"
                    }`}
                  >
                    {book.lastReadingDate ? (
                      <>
                        Last Page Read: <strong>{book.lastPageRead}</strong>{" "}
                        On{" "}
                        <strong>
                          {formatDateTime(book.lastReadingDate)}
                        </strong>
                      </>
                    ) : (
                      <strong className="text-orange-500">
                        Not Read Yet
                      </strong>
                    )}
                  </p>
                </>
              )}
              {book.isGifted === 1 && (
                <div className="mt-4">
                  <h2 className="text-lime-500 text-lg mb-4">
                    <FontAwesomeIcon
                      icon={faGifts}
                      className="text-red-500 text-4xl"
                    />
                  </h2>
                  <p className="text-yellow-200">
                    Gifted By : <strong>{book.gifterName}</strong>
                  </p>
                  <p className="text-white">
                    <strong>{book.giftMessage}</strong>
                  </p>
                  <p className="text-yellow-200">{book.gifterSignatureLine}</p>
                  <p className="book-author text-blue-500">{book.gifFor}</p>
                  <p className="book-author text-gray-200">
                    Gifted on : {formatDate(book.purchaseDate)}
                  </p>
                </div>
              )}
            </div>
          </div>
          <div className="flex mt-2 justify-center">
            <div className="tooltip-container w-20">
              <button
                className="ml-2 py-1 text-white rounded bg-purple-800"
                onClick={() =>
                  handleInstantReferralsListClick(book.bookId)
                }
              >
                <FontAwesomeIcon icon={faUserClock} />
              </button>
              <span className="tooltip">My Instant Referrals</span>
            </div>

            <div className="tooltip-container w-20">
              <button
                className="ml-2 py-1 text-white rounded bg-purple-800"
                onClick={() => handleViewBillClick(book.bookId)}
              >
                <FontAwesomeIcon icon={faFileInvoiceDollar} />
              </button>
              <span className="tooltip">
                Bill cum Receipt
              </span>
            </div>
          </div>
          {instantReferralViewClicked && (
            <div className="p-2">
              <p className="text-lg font-semibold text-blue-800 mb-4">My Instant Referral List for the Book</p>
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white border border-gray-300 shadow-md rounded-lg">
                  <thead>
                    <tr className="bg-blue-100">
                      <th className="px-4 py-2 text-left text-white">Username</th>
                      <th className="px-4 py-2 text-left text-white">Referral Bonus</th>
                      <th className="px-4 py-2 text-left text-white">Purchase Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {myBBList.map((bblist, index) => (
                      <tr key={index} className="border-t">
                        <td className="px-4 py-2 text-white">{bblist.userName}</td>
                        <td className="px-4 py-2 text-white">{(bblist.paymentAmount * 0.13).toFixed(2)}</td>
                        <td className="px-4 py-2 text-white">{formatDateTime(bblist.purchaseDate)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          { viewBillClicked && (
            <div className="p-2">
              <p className="text-lg font-semibold text-blue-800 mb-2">My Bill cum Receipt</p>
              {!myInvoice.invoice ? (
                <div>
                  <p className='text-orange-500 text-lg'>Invoice Not Found!!</p>
                </div>
              ) : (
                <div
                    className="page-content ml-2 mr-2 flex items-start"
                    style={{ minHeight: "100%" }}
                    dangerouslySetInnerHTML={{ __html: myInvoice.invoice }}
                />
              )}
            </div>
          )}
          <div className="flex flex-row mt-1 justify-center">
            <div className="tooltip-container w-20">
              <button
                className="py-1 text-white rounded bg-purple-800"
                disabled={book.isCollection}
                onClick={() =>
                  handleFlyOnTheWallClick(book.bookId, book.bookTitle)
                }
              >
                <FontAwesomeIcon icon={faUserPlus} />
              </button>
              <span className="tooltip">Allow Fly On The Wall</span>
            </div>

            <div className="tooltip-container w-20">
              <button
                className="py-1 text-white rounded bg-purple-800"
                disabled={book.isCollection}
                onClick={() =>
                  handleFlyerOnTheWallListClick(book.bookId, book.bookTitle)
                }
              >
                <FontAwesomeIcon icon={faUserTie} />
              </button>
              <span className="tooltip">
                List of My Flyers On The Wall for This Book
              </span>
            </div>

            <div className="tooltip-container w-20">
              <button
                className="py-1 text-white rounded bg-purple-800"
                disabled={true || book.isCollection}
                onClick={() => handleDcrClick(book.bookId, book.bookTitle)}
              >
                <FontAwesomeIcon icon={faUserFriends} />
              </button>
              <span className="tooltip">Add Digital Co-Reader</span>
            </div>

            <div className="tooltip-container w-20">
              <button
                className="py-1 text-white rounded bg-purple-800"
                disabled={true}
                onClick={() =>
                  handleDcrListClick(book.bookId, book.bookTitle)
                }
              >
                <FontAwesomeIcon icon={faUsers} />
              </button>
              <span className="tooltip">
                List of My Digital Co-readers for This Book
              </span>
            </div>
          </div>
          {flyOnTheWall && (
            <div className="flex justify-center">
              <Tooltip text={"Allow Fly On The Wall"} position={"top"}>
                <button
                  className="ml-2 py-1 text-white rounded bg-orange-500"
                  disabled={false}
                  style={{ maxWidth: "160px" }}
                >
                  <FontAwesomeIcon icon={faUserPlus} />
                </button>
              </Tooltip>
              <Tooltip
                text={" Who All Are Flying On The Wall?!"}
                position={"top"}
              >
                <button
                  className="ml-2 py-1 text-white rounded bg-orange-500"
                  disabled={false}
                  style={{ maxWidth: "200px" }}
                >
                  <FontAwesomeIcon icon={faUserTie} />
                </button>
              </Tooltip>
            </div>
          )}
          {book.buyingMethod === "MLM" && (
            <div className='flex flex-col place-items-center'>
              <div className='flex flex-col place-items-center'>
                <div className='flex flex-col place-items-center'>
                  <p className="text-m lg:text-lg text-yellow-200 text-center mb-2">
                    You are eligible for Valueshare / Multi Level Referral program. Under this program you can earn active & passive income as per
                    following chart:{" "}
                  </p>
                </div>
                <div>
                  <button
                    className="text-xs w-80 px-1 py-1 text-white rounded bg-blue-700"
                    onClick={() => setShowTable(!showTable)}
                  >
                    Click here to see Multi-Level referral income chart
                  </button>
                  {showTable && <BookEarningCalculator param={book.salesPrice} />}
                </div>
              </div>
              <div className="flex justify-center">
                <p className="text-lg text-yellow-200 mt-2">
                  My Referrer:{" "}
                  <strong className="text-lg">{book.advisorName}</strong>
                </p>
              </div>
              <div className="mt-2 justify-center place-items-center border rounded-md border-cyan-300 p-4">
                <button
                  className="flex justify-center text-xs lg:text-sm p-1 w-40 lg:w-64 text-white rounded bg-purple-700"
                  onClick={() => {
                    handleMyReferralsListClick(
                      book.bookId,
                      book.userCode,
                      book.userLevel
                    );
                    toggleReferralsList();
                  }}
                >
                {showReferralsList ? "Hide Direct Referrals List" : "Show Direct Referrals List"}
                </button>
                {showReferralsList && selectedBookId === book.bookId && (
                  <div className="mt-2">
                    {myReferralsList.length === 0 ? (
                      <p className="text-red-500">
                        There is No Direct Referral Sales Yet for the book{" "}
                        {book.bookTitle}!!
                      </p>
                    ) : (
                      <div className="flex flex-col gap-2">
                        {myReferralsList.map((referral, index) => (
                          <div
                            key={index}
                            className="text-xs lg:text-sm bg-black border-b border-b-blue-400 text-blue-500 ml-4 mr-4 mb-1 p-2 rounded"
                          >
                            <p className='text-xs lg:text-sm bg-black'>
                              {index + 1}. User: {referral.userName} ({referral.userCode})
                            </p>

                            <p className='text-xs lg:text-sm bg-black'>
                              Purchase Date:{" "}
                              {referral.purchaseDate
                                ? new Date(referral.purchaseDate).toLocaleDateString()
                                : "-"}
                            </p>

                            <p className='text-xs lg:text-sm bg-black'>
                              Purchase Price:{" "}
                              {referral.salesPrice
                                ? referral.salesPrice.toFixed(2)
                                : "0.00"}
                            </p>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="mt-4 flex flex-col justify-center border border-teal-300 rounded-md p-2">
                <div className="flex flex-col gap-4 mb-4">
                  <div className='flex flex-row gap-2'>
                    <select
                      value={selectedPeriod}
                      onChange={(e) => setSelectedPeriod(e.target.value)}
                      className="p-2 h-10 border rounded bg-white text-black"
                    >
                      {periodOptions.map((period) => (
                        <option key={period} value={period}>
                          {period}
                        </option>
                      ))}
                    </select>

                    <select
                      value={selectedLevel}
                      onChange={(e) => setSelectedLevel(e.target.value)}
                      className="p-2 h-10 border rounded bg-white text-black"
                    >
                      <option value="All">All Levels</option>
                      {[1,2,3,4,5,6,7,8].map((lvl) => (
                        <option key={lvl} value={lvl}>
                          Level {lvl}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Custom Date */}
                  {selectedPeriod === "Custom Date Range" && (
                    <div className='flex flex-row gap-2'>
                      <input
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        className="p-2 h-10 text-black bg-white border rounded"
                      />
                      <input
                        type="date"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                        className="p-2 h-10 text-black bg-white border rounded"
                      />
                    </div>
                  )}
                  </div>
                </div>
                <button
                  className="text-xs lg:text-sm p-1 w-64 lg:w-80 text-white rounded bg-orange-500"
                  onClick={() => handleGetDownTheLineReferralList(book.bookId)}
                  disabled={downTheLineReferralsDataClicked}
                >
                  Show My Referrals / ValueShare Income
                </button>
                {downTheLineReferralsDataClicked && downTheLineReferralsList.length>0 && selectedBookId === book.bookId ? (
                    <div className="p-2 mt-2 text-red-800 overflow-x-auto">
                      <table className="min-w-full">
                        <thead>
                          <tr>
                            <th>Level</th>
                            <th>Count</th>
                            <th>Amount</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Object.keys(aggregatedLevels).length > 0 ? (
                            <>
                              {Object.keys(aggregatedLevels).map((level) => (
                                <tr key={level}>
                                  <td>Level {level}</td>
                                  <td>{aggregatedLevels[level].count}</td>
                                  <td>{aggregatedLevels[level].totalCom.toFixed(2)}</td>
                                </tr>
                              ))}

                              {/* 🔹 Total Row */}
                              <tr className="font-bold bg-gray-600 text-white">
                                <td>Total (₹)</td>
                                <td>
                                  {Object.values(aggregatedLevels).reduce(
                                    (sum, item) => sum + item.count,
                                    0
                                  )}
                                </td>
                                <td>
                                  {Object.values(aggregatedLevels)
                                    .reduce((sum, item) => sum + item.totalCom, 0)
                                    .toFixed(2)}
                                </td>
                              </tr>
                            </>
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center py-4">
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <>
                      <p className='text-yellow'>You Do Not Have Any Direct or Indirect Referrals Yet!!</p>
                    </>
                  )}
              <div>
            </div>
          </div>
        )}
      </div>
    ))}
  </div>
  );
};

export default BookShelfListComponent;
